import * as React from 'react';
import styled from 'styled-components';
import { IDateRange } from '../../../data/providers/settings/dates/dateRangeProvider';
import { Entity } from '../../../data/types';
import { toDateRangeString } from '../../../utils/date';
import { Column } from '../../layout/Column';
import { Row } from '../../layout/Row';

interface IProps {
  targetTimeframe?: IDateRange;
  targetSecondary?: string;
  targetEntity?: Entity;
  populationTimeframe?: IDateRange;
  populationSecondary?: string;
  populationEntityName?: string;
  reportName: string;
  isPdf?: boolean;
  noComparison?: boolean;
  asymmetry?: boolean;
}

export const ReportOverview = (props: IProps): React.ReactElement => {
  return (
    <Column>
      {!props.isPdf && (
        <TitleRow>
          <ReportTitle>{props.reportName}</ReportTitle>
        </TitleRow>
      )}
      {!props.noComparison && (
        <Container>
          <DataSetOverview
            entityName={props.targetEntity.name}
            secondary={props.targetSecondary}
            timeframe={toDateRangeString(
              props.targetTimeframe?.dateType,
              props.targetTimeframe?.dateRange
            )}
          />
          <Vs />
          <DataSetOverview
            entityName={props.populationEntityName}
            secondary={props.populationSecondary}
            timeframe={toDateRangeString(
              props.populationTimeframe?.dateType,
              props.populationTimeframe?.dateRange
            )}
          />
        </Container>
      )}
      {props.asymmetry && (
        <Container>
          <DataSetOverview
            entityName={toDateRangeString(
              props.targetTimeframe?.dateType,
              props.targetTimeframe?.dateRange
            )}
            secondary={props.targetSecondary}
            timeframe={''}
          />
        </Container>
      )}
    </Column>
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Container = styled(Row as any)`
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: var(--color-surface-6);
  padding: 5px;
`;

const Vs = (): React.ReactElement => {
  return (
    <VsContainer>
      <VsContent>Vs.</VsContent>
    </VsContainer>
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TitleRow = styled(Row as any)`
  margin: 10px auto;
`;

const VsContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ReportTitle = styled.h3``;

const VsContent = styled.h3`
  background-color: var(--color-surface-0);
  border-radius: 50%;
  padding: 10px;
`;

const DataSetContainer = styled.div`
  flex: 1;
  height: 100%;
  padding: 10px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  text-align: center;
  &:last-child {
    justify-content: flex-end;
  }
`;

interface IDataSetProps {
  entityName: string;
  timeframe: string;
  secondary?: string;
}
const DataSetOverview = (props: IDataSetProps): React.ReactElement => {
  return (
    <DataSetContainer>
      <Column>
        <div>{props.entityName}</div>
        {props?.secondary && <div>{props.secondary}</div>}
        <div>{props.timeframe}</div>
      </Column>
    </DataSetContainer>
  );
};
